<template>
    <div class="login-container">
      <div class="glass-card">
        <h1 class="title">Email Verification</h1>
  
        <div v-if="isSuccess" class="success-message">
          <p class="subtitle">Success!</p>
          {{ successMessage }}
        </div>
  
        <div v-if="!isSuccess" class="error-message">
           <p class="subtitle">Verification Failed</p>
           {{ errorMessage }}
        </div>
  
        <div class="action-buttons">
          <router-link to="/login" class="login-btn">
            Go to Login
          </router-link>
          <router-link v-if="showResendLink" to="/resend-verification" class="secondary-link"> Resend Verification Email?
           </router-link>
        </div>
  
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'VerificationResult',
    data() {
      return {
        isSuccess: false,
        errorCode: null, // To store the message code from the query param
        successMessage: 'Your email address has been successfully verified! You can now log in.', // Default success message
      };
    },
    computed: {
      /**
       * Maps error codes from the URL query parameter to user-friendly messages.
       */
      errorMessage() {
        switch (this.errorCode) {
          case 'missing_token':
            return 'The verification link is incomplete. Please try copying the link from your email again or request a new one if needed.';
          case 'invalid_or_expired_token':
            return 'The verification link is invalid or has expired. Please request a new verification email.';
          case 'server_error':
            return 'An unexpected error occurred on the server while verifying your email. Please try again later or contact support.';
          default:
            return 'An unknown error occurred during email verification. Please try again or contact support.';
        }
      },
      /**
       * Determines if the "Resend Verification" link should be shown.
       * For example, show it only if the token was invalid or expired.
       */
      showResendLink() {
          return this.errorCode === 'invalid_or_expired_token';
      }
    },
    created() {
      // Process query parameters when the component is created
      const query = this.$route.query;
      this.isSuccess = query.success === 'true';
      this.errorCode = query.message || null; // Get the error code if success is not true
  
      // Optional: You could update the page title
      // document.title = this.isSuccess ? 'Verification Successful' : 'Verification Failed';
  
       // Optional: Clear the query params from the URL bar for cleanliness,
       // but be careful if the user refreshes the page.
       // if(Object.keys(query).length > 0) {
       //     this.$router.replace({ query: null });
       // }
    },
  };
  </script>
  
  <style scoped>
  /* Reuse styles from your Login.vue for consistency */
  .login-container { display: flex; justify-content: center; align-items: center; min-height: 100vh; background: linear-gradient(-45deg, #141e30, #243b55, #141e30); background-size: 400% 400%; animation: gradientAnimation 10s ease infinite; padding: 20px; }
  .glass-card { background: rgba(255, 255, 255, 0.15); backdrop-filter: blur(12px); border-radius: 12px; padding: 40px; text-align: center; box-shadow: 0 4px 30px rgba(0, 0, 0, 0.2); width: 450px; max-width: 100%; }
  .title { font-size: 24px; color: #fff; font-weight: bold; margin-bottom: 10px; }
  .subtitle { color: rgba(255, 255, 255, 0.9); font-size: 16px; font-weight: bold; margin-bottom: 20px; }
  
  /* Message Styles */
  .success-message,
  .error-message {
    color: #fff; /* White text for contrast */
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 25px;
    border: 1px solid;
    font-size: 15px;
    line-height: 1.5;
  }
  .success-message {
    background-color: rgba(76, 175, 80, 0.3); /* Greenish background */
    border-color: rgba(76, 175, 80, 0.5);
  }
  .error-message {
    background-color: rgba(244, 67, 54, 0.3); /* Reddish background */
    border-color: rgba(244, 67, 54, 0.5);
  }
  .success-message .subtitle,
  .error-message .subtitle {
      margin-bottom: 8px; /* Smaller margin for subtitles within messages */
  }
  
  /* Action Buttons Area */
  .action-buttons {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px; /* Space between buttons/links */
  }
  
  /* Re-use login button style */
  .login-btn {
     display: inline-block; /* Make router-link behave like button */
     width: 80%;
     max-width: 250px; /* Max width for button */
     padding: 12px;
     font-size: 16px;
     font-weight: 500;
     border: none;
     border-radius: 8px;
     cursor: pointer;
     transition: transform 0.2s, box-shadow 0.2s;
     background: #4CAF50;
     color: white;
     text-decoration: none; /* Remove underline from router-link */
     text-align: center;
  }
  .login-btn:hover { transform: scale(1.05); box-shadow: 0 4px 10px rgba(255, 255, 255, 0.3); }
  
  /* Style for secondary links like 'Resend' */
  .secondary-link {
     color: rgba(255, 255, 255, 0.8);
     text-decoration: none;
     font-size: 14px;
     transition: color 0.3s;
  }
  .secondary-link:hover { color: #4CAF50; }
  
  
  @keyframes gradientAnimation { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }
  </style>